/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment } from 'react';
import moment from 'moment';
import Icon from '@salesforce/design-system-react/components/icon';
import Input from '@salesforce/design-system-react/components/input';

import MaterialVariant from '../../../../../../Shared/MaterialVariant';
import Collapsible from '../../../../../../common/Collapsible/Collapsible';
import { getHoldIcon } from '../../../../../../../util/utilityFunctions';
import { MAX_QUANTITY } from '../../../../../../../util/constants';
import { HandleCatalogCountFN, HandleInventoryCountFN } from '../AddPartsModal.types';
import { INVENTORY_CHANNELS } from '../useParts';
import { getIconByDate } from './helper';
import styles from './styles.module.scss';
import { Spinner } from '@salesforce/design-system-react';

interface InventorySectionProps {
  inventoryType: INVENTORY_CHANNELS;
  title?: string;
  loading: boolean;
  searching: boolean;
  inventory: any[];
  handleInventoryCounter?: HandleInventoryCountFN;
  handleCatalogCounter?: HandleCatalogCountFN;
  showMaterialVariant?: boolean;
  isInventoryReturn?: boolean;
  accountNumber?: string;
}

export default function InventorySection({
  inventoryType,
  title,
  loading,
  searching = false,
  inventory,
  handleInventoryCounter = () => { },
  handleCatalogCounter = () => { },
  showMaterialVariant = false,
  isInventoryReturn = false,
  accountNumber,
}: InventorySectionProps) {
  const holdIconPath = getHoldIcon();

  if (loading)
    return (
      <div className={styles.loading}>
        <Spinner size="small" />
      </div>
    );

  return (
    <section className="slds-p-around_large-1">
      {title && <p className={styles.title}>{title}</p>}
      {inventoryType !== INVENTORY_CHANNELS.CATALOG ? (
        <>
          {!loading &&
            inventory.map((subInv: any) => (
              <Fragment
                key={`inv-${inventoryType}-${subInv?.subInventoryCode}-${subInv?.productNumber}`}
              >
                {subInv?.productDescription &&
                  subInv?.productDescription.map((subInvCode: any) => (
                    <Collapsible
                      key={`product-${inventoryType}-${subInvCode?.subInventoryCode}-${subInvCode?.productNumber}`}
                      open={searching}
                      title={`${subInvCode?.subInventoryCode} - ${subInvCode?.subInventoryName}`}
                      disabled={!!accountNumber && subInvCode?.subInventoryCode !== accountNumber}
                      testId={subInvCode?.subInventoryCode}
                    >
                      {subInvCode?.value &&
                        subInvCode?.value?.map((item: any) => (
                          <div
                            data-testid="add-parts-modal-result"
                            className={`inventory-return-lot-info-name ${styles.paddingCatalog}`}
                            key={`item-${inventoryType}-${item?.productNumber}`}
                          >
                            <div className={styles.topContainer}>
                              {`${item.productNumber} ${item.name ? item.name.toUpperCase() : '--'
                                }`}
                              {showMaterialVariant && (
                                <>
                                  <br />
                                  <MaterialVariant item={item} />
                                </>
                              )}
                              {item.productOnHoldType === 'ITEM' && (
                                <>
                                  <img
                                    src={holdIconPath}
                                    className={`logo-image ${styles.holdLogo}`}
                                    alt="company"
                                  />
                                </>
                              )}
                            </div>

                            {item.value &&
                              item.value.map((valueItem: any) => {
                                const iconName = getIconByDate(valueItem?.expirationDate);
                                return (
                                  <div
                                    className={`${Number(valueItem.maxPermissibleValue) <= 0
                                      ? styles.lotInfoText
                                      : ''
                                      } ${styles.inventoryReturnLotInfo}`}
                                    key={`value-${inventoryType}-${valueItem?.productNumber}-${valueItem?.lotNumber}`}
                                  >
                                    <span className={styles.productTextSpan}>
                                      Lot #/Serial # - {valueItem.lotNumber || '--'}
                                      {item?.productOnHoldType === 'ITEM' ||
                                        (valueItem?.productOnHoldType === 'ITEM' && (
                                          <img
                                            src={holdIconPath}
                                            className={`logo-image ${styles.holdImage}`}
                                            alt="company"
                                          />
                                        ))}
                                      {(item?.serialRecalled &&
                                        item?.serialRecalled.includes(valueItem?.lotNumber)) ||
                                        (valueItem?.serialRecalled &&
                                          valueItem?.serialRecalled.includes(
                                            valueItem?.lotNumber
                                          ) && (
                                            <>
                                              <img
                                                src={holdIconPath}
                                                className={`logo-image ${styles.holdImage}`}
                                                alt="company"
                                              />
                                            </>
                                          ))}{' '}
                                      <br />
                                      <br />
                                      Expiration Date:{' '}
                                      {valueItem.expirationDate
                                        ? moment(valueItem.expirationDate).format('MM/DD/YYYY')
                                        : '--'}
                                      {valueItem?.expirationDate && iconName && (
                                        <Icon
                                          category="utility"
                                          name={iconName}
                                          size="x-small"
                                          className={styles?.[`icon-${iconName}`]}
                                        />
                                      )}
                                    </span>

                                    <div data-testid={`parts-inventory-counter-${valueItem.lotNumber || 'no-lot'}`}>
                                      <Input
                                        id="counter-input-3"
                                        styleContainer={{ width: '110px' }}
                                        styleInput={{ padding: '0px' }}
                                        minValue={0}
                                        maxValue={valueItem.maxPermissibleValue}
                                        onChange={(_, data): void => {
                                          handleInventoryCounter(
                                            data,
                                            valueItem,
                                            inventory,
                                            inventoryType
                                          );
                                        }}
                                        value={valueItem.counterValue}
                                        variant="counter"
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        ))}
                    </Collapsible>
                  ))}
              </Fragment>
            ))}
        </>
      ) : (
        <>
          {!loading &&
            inventory.map((product: any) => (
              <div
                className={styles.container}
                key={`catalogid-${inventoryType}-${product?.productId}`}
              >
                <div className={styles.catalogContainer}>
                  <div className={styles.topContainer}>
                    {`${product.productNumber} ${product.productdescription}`}
                    {product.productOnHold ? (
                      <>
                        <img
                          src={holdIconPath}
                          className={`logo-image ${styles.holdLogo}`}
                          alt="company"
                        />
                        On Hold
                      </>
                    ) : (
                      ''
                    )}
                  </div>

                  <div data-testid="parts-catalog-counter">
                    <Input
                      id="counter-input-3"
                      styleInput={{ width: '110px' }}
                      minValue={0}
                      maxValue={MAX_QUANTITY}
                      onChange={(_, data): void => {
                        handleCatalogCounter(data, product, inventory, (isInventoryReturn ? inventoryType : null));
                      }}
                      value={product.counterValue}
                      variant="counter"
                    />
                  </div>
                </div>
                {showMaterialVariant && <MaterialVariant item={product} />}
              </div>
            ))}
        </>
      )}
    </section>
  );
}
